import "./sass/main.scss";
import "./scripts/settings";
import "./scripts/game";
